import { TagFill } from "react-bootstrap-icons";
import ImageIcon from "../shared/image_icon";

const Badges = ({ event, t, onlyMax }) => {
  return (
    <>
      <small
        className="badge badge-primary rounded-pill"
        style={{ backgroundColor: event.activity_group?.accent_color }}
      >
        <span className="d-flex">
          <ImageIcon name="user-black" width={20} height={20} />
          <span className="ms-1">
            {onlyMax ? `${event.max_participants} ` : `${event.users_events_count}/${event.max_participants} `}
          </span>
        </span>
      </small>

      {event.tag && (
        <div
          className="ms-1 badge badge-primary rounded-pill"
          style={{ backgroundColor: event.activity_group?.accent_color }}
        >
          <div className="d-flex">
            <TagFill size={19} />
            <span className="ms-1">{event.tag}</span>
          </div>
        </div>
      )}

      <div
        className="ms-1 badge badge-primary rounded-pill"
        style={{ backgroundColor: event.activity_group?.accent_color }}
      >
        <div className="d-flex">
          <ImageIcon name="currency-black" width={20} height={20} />
          <span className="ms-1">{event.is_paid ? t("common:paid") : t("common:free")}</span>
        </div>
      </div>
    </>
  );
};

export default Badges;
